// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-plus.js';

import { paths } from '../generated/file-plus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-plus', Original, paths);
